import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { EnvironmentService } from '../services';

export const apiKeyInterceptor: HttpInterceptorFn = (req, next) => {
    const envService = inject(EnvironmentService);
    const apiKey = envService.apiKey;

    if (apiKey && req.url.includes('planning-projects')) {
        req = req.clone({
            setHeaders: { 'X-APPLICATION-API-KEY': apiKey }
        });

        if (req.url.includes('data/visuals')) {
            req = req.clone({
                setHeaders: { Accept: 'application/json' }
            });
        }
    }

    return next(req);
};
